















// @ is an alias to /src
import TitleBar from '@/modules/core/components/TitleBar.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import UsersTable from '../components/UsersTable.vue';
import { RoleType, roles } from '@shared/common/types';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    CardComponent,
    UsersTable,
  },
})
export default class UserList extends Vue {
  public get filteredRoles(): RoleType[] {
    const rolesInRoute = this.$route.query.role as RoleType | RoleType[];

    if (!rolesInRoute) {
      return [];
    }

    if (!Array.isArray(rolesInRoute)) {
      return [rolesInRoute];
    }

    return rolesInRoute;
  }

  public get titleStack(): string[] {
    return ['Admin', this.cardTitle];
  }

  public get newUserLabel(): string {
    if (this.filteredRoles.length === 0 || this.filteredRoles.length > 1) {
      return 'Nouvel utilisateur';
    } else {
      return (
        (roles[this.filteredRoles[0]] &&
          roles[this.filteredRoles[0]].creationLabel) ||
        'Nouvel utilisateur'
      );
    }
  }

  public get cardTitle(): string {
    if (this.filteredRoles.length === 0 || this.filteredRoles.length > 1) {
      return 'Utilisateurs';
    } else {
      return (
        (roles[this.filteredRoles[0]] &&
          roles[this.filteredRoles[0]].pluralLabel) ||
        'Utilisateurs'
      );
    }
  }
}
